import React from 'react';
import PlainDropDownList from './PlainDropdownList';

const DISEASES = [
    'No Past Medical Conditions or Hospitalizations',
    'High Blood Pressure (Hypertension)', 'Asthma', 'COPD/Emphysema/Chronic Bronchitis', 'Hypothyroidism (low thyroid, on medication)',
    'Atrial Fibrillation', 'Heart Disease', 'Blood Clots in legs or lungs (DVT or Pulmonary Embolism)', 'Kidney Stones', 'Back Pain', 'Depression',
    'Anxiety/Panic', 'Other... (please specify below)',
];

export default class DiseaseDropDownList extends PlainDropDownList {
    constructor(props) {
        super(props);
        this.placeholder = loc('disease-placeholder');
        this.items = DISEASES;
    }
}



// WEBPACK FOOTER //
// ./src/components/controls/DiseaseDropDownList.js